import { LayoutPrincipal } from '@/components/layout';
import { DetalleUtilidadPantalla } from '@/pages/DetalleUtilidadPantalla';
import { IndirectosPantalla } from '@/pages/IndirectosPantalla';
import { IngresosUtilidadPantalla } from '@/pages/IngresosUtilidadPantalla';
import { MovimientosUtilPantalla } from '@/pages/MovimientosUtilPantalla';
import { NoEncontradoPantalla } from '@/pages/NoEncontradoPantalla';
import { ObrasPantalla } from '@/pages/ObrasPantalla';
import { ResumenUtilidadesPantalla } from '@/pages/ResumenUtilidadesPantalla';
import { UtilidadNetaPantalla } from '@/pages/UtilidadNetaPantalla';
import { Navigate, createBrowserRouter } from 'react-router-dom';

export const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <LayoutPrincipal />,
      children: [
        { index: true, element: <Navigate to="/resumen" replace /> },
        { path: 'resumen', element: <ResumenUtilidadesPantalla /> },
        { path: 'ingresos', element: <IngresosUtilidadPantalla /> },
        { path: 'detalle', element: <DetalleUtilidadPantalla /> },
        { path: 'neta', element: <UtilidadNetaPantalla /> },
        { path: 'movimientos', element: <MovimientosUtilPantalla /> },
        { path: 'indirectos', element: <IndirectosPantalla /> },
        { path: 'obras', element: <ObrasPantalla /> },
        { path: '*', element: <NoEncontradoPantalla /> },
      ],
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionErrorRevalidation: true,
    },
  },
);
